<template>
  <div
    class="relative group flex items-center w-full transition duration-100 ease-in-out border rounded focus-within:ring-2 focus-within:ring-blue-500 focus-within:outline-none focus-within:ring-opacity-50"
    :class="classes"
  >
    <div class="flex items-center w-full h-full">
      <slot name="leading" />

      <select
        v-model="_value"
        :disabled="disabled"
        class="absolute left-0 appearance-none h-full bg-transparent w-full outline-none"
        :class="classes"
      >
        <option :value="null" />
        <option v-for="(option, key) in options" :key="key" :value="key" class="bg-primary">
          {{ option }}
        </option>
      </select>
    </div>

    <slot name="trailing">
      <b-icon icon="chevronDown" />
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useInput, type Variants, type Sizes } from '~/composables/input';

defineOptions({
  name: 'BSelectInput'
});

const props = defineProps<{
  modelValue: string | number;
  options?: Object;
  variant?: keyof Variants;
  size?: keyof Sizes;
  flat?: boolean;
  disabled?: boolean;
}>();

const emit = defineEmits(['update:modelValue', 'input', 'change']);

const { classes } = useInput(
  {
    variant: props.variant || 'base',
    size: props.size || 'md',
    flat: props.flat || false,
    disabled: props.disabled || false,
  },
  emit as (event: string, ...args: any[]) => void
);

const _value = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value);
  }
});
</script>
